import { CustomButton } from "components/form";
import React, { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { CustomModal } from "components/modals/ModalBox";
import { formatToDDMMYYYY } from "utils/dateFormat";
import Pagination from "react-js-pagination";
import useFullPageLoader from "common/UseFullPageLoader";
import { FaRegTrashAlt } from "react-icons/fa";
// import useDebounce from "common/UseDebounce";
import NotFound from "common/NotFound";
import { toast } from "sonner";
import { charLimit } from "utils/formValidator";
import { limitOption } from "constants/staticData";
import findSerialNumber from "utils/findSerialNumber";
import { getValueOrFallback } from "utils/common";
import DeleteFaq from "./DeleteFaq";
import { SlRefresh } from "react-icons/sl";
import { AddFAQModel } from "./AddFaq";
import { getFaqApi } from "services/faq";

const FAQManagement = () => {
  const [deleteModal, setDeleteModal] = useState(false);
  const [faqList, setFaqList] = useState([]);
  const [addFaqModal, setAddFaqModal] = useState(false);
  // const [search, setSearch] = useState("");
  // const debouncedValue = useDebounce(search, 300);
  const [searchParams, setSearchParams] = useSearchParams();
  const [selectedFaqDetail, setSelectedFaqDetail] = useState({});
  const [total, setTotal] = useState(null);
  const activePage = +searchParams.get("page") || 1;
  const limit = +searchParams.get("limit") || 10;
  const [descriptionModal, setDescriptionModal] = useState(false);
  const [description, setDescription] = useState("");
  const [loader, onShow, onHide] = useFullPageLoader();
  const [descriptonTitle,setDescriptionTitle] = useState("Question")

  // delete handler
  const deleteFaqHandler = (data) => {
    setSelectedFaqDetail(data);
    setDeleteModal(true);
  };

  // handle limit of page
  const handleLimit = (event) => {
    searchParams.set("limit", event.target.value);
    searchParams.delete("page")
    setSearchParams(searchParams);
  };

  /*************Reset Filter Handler*********************/
  const resetFilterHandler = () => {
    searchParams.delete("page");
    searchParams.delete("limit");
    setSearchParams(searchParams);
  };
  //*********Handel Pagination********* */
  const handlePageChange = (event) => {
    searchParams.set("page", event);
    setSearchParams(searchParams);
  };

  // Handle answer description
  const handerAnswerDescription = (data,title) => {
    setDescriptionModal(true);
    setDescriptionTitle(title||"")
    setDescription(
      <p
        dangerouslySetInnerHTML={{
          __html: data,
        }}
      ></p>
    );
  };

  // faq list handler
  const faqListHandler = async () => {
    try {
      onShow();
      const reqData = {
        page: activePage,
        limit,
      };
      const { data: responseData, status } = await getFaqApi(reqData);
      if (status === 200) {
        setTotal(responseData?.data?.total);
        setFaqList(responseData?.data?.faq);
      }
    } catch (e) {
      toast.error(e.message);
    } finally {
      onHide();
    }
  };

  // close modal
  const closeModel = () => {
    setSelectedFaqDetail({});
    setAddFaqModal(false);
    setDeleteModal(false);
  };

  // useEffect(() => {
  //   if (Number(activePage) === 1) {
  //     searchParams.delete("page");
  //     setSearchParams(searchParams);
  //   }
  //   faqListHandler();
  // }, [searchParams, activePage, limit]);

  // useEffect(() => {
  //   if (search) {
  //     searchParams.delete("page");
  //   }
  // }, [search]);

  return (
    <>
      <div className="student_management">
        <div className="dashboard_title">
          <h3>FAQ Management</h3>
        </div>
        <div className="button_section_wrap">
          <div className="search_wrapper">
            {/* <SearchBar
              placeholder={"Search..."}
              onChange={(e) => setSearch(e.target.value)}
              value={search}
            /> */}
            <CustomButton
              type="button"
              className="button"
              onClick={() => {
                setAddFaqModal(true);
              }}
            >
              Add FAQ
            </CustomButton>
            <CustomButton onClick={resetFilterHandler}>
              <SlRefresh />
            </CustomButton>
          </div>
        </div>
        <div className="card">
          <div className="card-body">
            <div className="table_wrap ">
              <table className="table custom_table">
                <thead>
                  <tr>
                    <th className="nowrap text-center">S.No</th>
                    <th className="nowrap text-center">Question</th>
                    <th className="nowrap text-center">Answer</th>
                    <th className="nowrap text-center">Created At</th>
                    <th className="nowrap text-center">Action</th>
                  </tr>
                </thead>
                <tbody>
                  {loader}
                  {faqList && faqList.length ? (
                    faqList.map((data, index) => {
                      return (
                        <tr key={index}>
                          <td className="nowrap text-center">
                            {findSerialNumber(index, activePage, limit)}
                          </td>
                          <td className="nowrap text-center">
                            {/* {getValueOrFallback(data?.question)} */}
                            {data?.question.length > 50 ? (
                              <div className="">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: charLimit(data?.question, 30),
                                  }}
                                ></span>
                                &nbsp;
                                <button
                                  type="button"
                                  onClick={() => handerAnswerDescription(data?.question,"Question")}
                                  className="color-blue"
                                >
                                  Read More
                                </button>
                              </div>
                            ) : (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: data?.question,
                                }}
                              ></p>
                            )}
                          </td>
                          <td className="nowrap text-center">
                            {data?.answer.length > 50 ? (
                              <div className="">
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: charLimit(data?.answer, 30),
                                  }}
                                ></span>
                                &nbsp;
                                <button
                                  type="button"
                                  onClick={() => handerAnswerDescription(data?.answer,"Answer")}
                                  className="color-blue"
                                >
                                  Read More
                                </button>
                              </div>
                            ) : (
                              <p
                                dangerouslySetInnerHTML={{
                                  __html: data?.answer,
                                }}
                              ></p>
                            )}
                          </td>
                          <td className="icon_wrap text-center">
                            {formatToDDMMYYYY(data?.createdAt)}
                          </td>
                          <td>
                            <div className="icon_wrap text-center">
                              <Link
                                to=""
                                className="icon_button"
                                onClick={() => deleteFaqHandler(data)}
                              >
                                <FaRegTrashAlt />
                              </Link>
                              {/* <Link
                                onClick={() => {
                                  setEditModal(true);
                                  setInputData(data);
                                }}
                                className="icon_button"
                              >
                                <FaRegEdit />
                              </Link> */}
                            </div>
                          </td>
                        </tr>
                      );
                    })
                  ) : (
                    <NotFound
                      cols={7}
                      msg={"FAQ data not found"}
                      onHide={onHide}
                    />
                  )}
                </tbody>
              </table>
            </div>
            <div className="pagination-wrapper">
              <div className="Pagination">
                <select
                  className="input form-control"
                  value={limit}
                  onChange={handleLimit}
                >
                  {limitOption &&
                    limitOption.length > 0 &&
                    limitOption.map((limitValue) => (
                      <option key={limitValue.value} value={limitValue.value}>
                        {limitValue.label}
                      </option>
                    ))}
                </select>
              </div>
            </div>
            {total > limit && (
              <div className="pagination-wrapper">
                <div className="Pagination">
                  <Pagination
                    activePage={activePage}
                    previousLabel={"previous"}
                    nextLabel={"next"}
                    itemsCountPerPage={limit}
                    totalItemsCount={total}
                    pageRangeDisplayed={5}
                    onChange={handlePageChange}
                    hideDisabled={true}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
      {/* Delete FAQ Modal */}
      {deleteModal && (
        <DeleteFaq
          deleteModal={deleteModal}
          selectedFaqDetail={selectedFaqDetail}
          setFaqList={setFaqList}
          closeModel={closeModel}
        />
      )}
      {addFaqModal && (
        <AddFAQModel
          addFaqModal={addFaqModal}
          faqListHandler={faqListHandler}
          closeModel={closeModel}
        />
      )}
      {/* <EditFAQModel
        setEditModal={setEditModal}
        editModal={editModal}
        faqListHandler={faqListHandler}
        inputData={inputData}
        types={types}
        setInputData={setInputData}
      /> */}
      {/* Description Modal */}

      {descriptionModal && (
        <CustomModal
          className={"add_model"}
          show={descriptionModal}
          handleClose={() => {
            setDescriptionModal(false);
          }}
        >
          <h3>{descriptonTitle}</h3>
          <h7>{description}</h7>
        </CustomModal>
      )}
    </>
  );
};

export default FAQManagement;
